import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import { getRouteRobotsDirective } from './routeIndexing'

export function NoIndexMeta({ follow = true }) {
  return (
    <Helmet>
      <meta
        name="robots"
        content={follow ? 'noindex,follow' : 'noindex,nofollow'}
      />
    </Helmet>
  )
}

function RouteIndexingMeta() {
  const { pathname } = useLocation()
  const directive = getRouteRobotsDirective(pathname)

  if (!directive) return null

  return (
    <Helmet>
      <meta name="robots" content={directive} />
    </Helmet>
  )
}

export default RouteIndexingMeta
